import i18n from 'live/services/i18n'

import { IBarrierStatus, IBarrierStatusDTO, IBarrierStatusSpecialStatus } from '../types'
import { SpecialStatus } from '../types/enums'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export interface IBarrierStatusCustomNameRequest {
    id: number
    statusCustomName: string
}

export const getListBarrierStatus = async (): Promise<IBarrierStatusSpecialStatus[]> => {
    const sortFunction = (s1, s2) => s2.priorityOrder - s1.priorityOrder
    const data = (await getBarrierStatus()).sort(sortFunction)

    return data
}

export const getBarrierStatus = async (): Promise<IBarrierStatusSpecialStatus[]> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierStatus}/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getBarrierStatusCustomNameMappedByDefaultStatus = async (): Promise<Map<
    number,
    IBarrierStatusSpecialStatus
>> => {
    const map = new Map<number, IBarrierStatusSpecialStatus>()
    const data = await getBarrierStatus()
    data.forEach(el => {
        map.set(el.id, el)
    })

    return map
}

export const updateBarrierStatusCustomNames = async (
    body: IBarrierStatusCustomNameRequest[]
): Promise<IBarrierStatusSpecialStatus[]> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierStatus}/custom_name`, {
        method: 'PATCH',
        credentials: 'same-origin',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const deleteBarrierStatus = async (id: number): Promise<void> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierStatus}/${id}`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? i18n('Error on delete bowtie'))
        }
    })
}

export const updateOrCreateBarrierStatus = async (body: IBarrierStatusDTO): Promise<IBarrierStatusSpecialStatus[]> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierStatus}/updateorcreate`, {
        method: 'PATCH',
        credentials: 'same-origin',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
